<!--业主管理信息列表-->
<template>
  <div class="ownerManagerBody">
    <OwnerManagerList ref="ownerManagerList" @add="addNewOwner" @view="openOwnerInfoViewDialog" @edit="editOwnerInfo">
    </OwnerManagerList>
    <OwnerInfoViewDialog ref='ownerInfoViewDialog'></OwnerInfoViewDialog>
    <addNewOwnerDialog ref='addNewOwnerDialog' @saveSuccess="saveSuccess"></addNewOwnerDialog>
  </div>
</template>
<script>
  import OwnerManagerList from './OwnerManagerList.vue'
  import OwnerInfoViewDialog from './dialogs/OwnerInfoViewDialog.vue'
  import ownerManagerStore from './ownerManagerStore.js'
  import addNewOwnerDialog from './dialogs/addNewOwnerDialog.vue'
  export default {
    components: {
      OwnerManagerList,
      OwnerInfoViewDialog,
      addNewOwnerDialog,
    },
    props: {},
    data () {
      return {
        newOwnerData: {},
        bindDeviceNo: {},
      }
    },
    created () {
      debugPage=this
      //初始化已经绑定的设备
      ownerManagerStore.commit('getBindedDeviceNos')
    },
    mounted () {
      ownerManagerStore.commit('setNowUnit',this.nowUnit)
      ownerManagerStore.commit('getAllRoles')
    },
    destroyed () {
    },
    computed: {
      nowUser () {
        return this.$store.userStore.state.nowUserInfo
      },
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      ownerRoleId () {
        return ownerManagerStore.state.ownerRoleId
      },
      bindedDeviceNos () {
        return ownerManagerStore.state.bindedDeviceNos
      },
    },
    watch: {
      nowUnit (nv,ov) {
        ownerManagerStore.commit('setNowUnit',nv)
      }
    },
    methods: {
      viewDetails (item) {
        this.$emit('viewDetails',item)
      },
      addNewOwner () {
        this.$refs.addNewOwnerDialog.title="新增业主"
        this.$refs.addNewOwnerDialog.ownerForm={
          id: '',
          rfid: '',
          username: '',
          userCode: '',
          gender: '男',
          mobile: '',
          address: '',
          password: '',
          password2: '',
          accountTime: new Date().getTime(),
          cardNumbers: '',
          cardTypes: 'ICBC',
          balanceAlarm: '',
          isAutomaticBrake: '否',
          amountOfArrears: '',
          cardState: '否',
          reportDir: '',
        }
        this.$refs.addNewOwnerDialog.divideList=[];
        this.$refs.addNewOwnerDialog.isEdit=true
        this.$refs.addNewOwnerDialog.addOwnerShow=true
      },
      editOwnerInfo (userData) {
        this.$refs.addNewOwnerDialog.title="编辑业主"
        userData.isAutomaticBrake=userData.isAutomaticBrake==0? '否':'是'
        userData.cardState=userData.cardState==-1? '否':'是'
        userData.password2=userData.password
        this.$refs.addNewOwnerDialog.ownerForm=copy(userData)
        this.$refs.addNewOwnerDialog.divideList=[];
        this.$refs.addNewOwnerDialog.refreshDivideList();
        this.$refs.addNewOwnerDialog.isEdit=false
        this.$refs.addNewOwnerDialog.addOwnerShow=true
      },
      openOwnerInfoViewDialog (userData) {
        //debugger
        ownerManagerStore.state.nowOwnerInformation=userData
        this.$router.push('/ownerManagerView')
      },
      saveSuccess () {
        //保存成功
        this.$refs.ownerManagerList.search()
      }
    }
  }
</script>

<style scoped>
  .ownerManagerBody {
    padding: 10px;
  }

  .dialog-device {
    width: 50%;
    min-height: 200px;
    max-height: 400px;
    margin-left: 40px;
  }

  .dialog-from {
    width: 50%;
    height: 100%;
  }

  .el-dialog__body {
    display: flex;
    align-items: center;
  }
</style>